var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M.164 6.88a.494.494 0 0 0 .337.86h1.002v6.433c0 .546.447.99 1 .99h4.316v-2.818c0-.547.447-.99 1-.99h.363c.552 0 1 .443 1 .99v2.817h4.316c.552 0 1-.443 1-.99V7.742h1.001a.494.494 0 0 0 .337-.86L8.673.42a1.007 1.007 0 0 0-1.346 0z"
  })));
};
export default SvgIconHome;